export type LogoLayout = 'wide' | 'standard' | 'tall';

function toPositiveNumber(value: number | null | undefined): number | null {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

export function getLogoLayout(width: number | null | undefined, height: number | null | undefined): LogoLayout {
  const logoWidth = toPositiveNumber(width);
  const logoHeight = toPositiveNumber(height);

  if (!logoWidth || !logoHeight) return 'standard';

  const aspectRatio = logoWidth / logoHeight;
  if (aspectRatio >= 3) return 'wide';
  if (aspectRatio <= 0.75) return 'tall';
  return 'standard';
}
